exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tl-confirm-dialog .btn-secondary {\n  background-color: #868e96;\n  border-color: #868e96; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/vendor/treeline-shared-components/confirm-dialog/confirm-dialog.scss
 ** module id = 777
 ** module chunks = 1 2 108
 **/